export default __webpack_public_path__ + "static/media/case0-1.f44eb8da.png";